/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { QuoteWorkUnit } from './';
import {
    QuoteWorkUnitFromJSON,
    QuoteWorkUnitFromJSONTyped,
    QuoteWorkUnitToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuoteWorkRate
 */
export interface QuoteWorkRate {
    /**
     * 
     * @type {QuoteWorkUnit}
     * @memberof QuoteWorkRate
     */
    unit: QuoteWorkUnit;
    /**
     * 
     * @type {number}
     * @memberof QuoteWorkRate
     */
    value: number;
}

/**
 * Check if a given object implements the QuoteWorkRate interface.
 */
export function instanceOfQuoteWorkRate(value: object): value is QuoteWorkRate {
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function QuoteWorkRateFromJSON(json: any): QuoteWorkRate {
    return QuoteWorkRateFromJSONTyped(json, false);
}

export function QuoteWorkRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteWorkRate {
    if (json == null) {
        return json;
    }
    return {
        
        'unit': QuoteWorkUnitFromJSON(json['unit']),
        'value': json['value'],
    };
}

export function QuoteWorkRateToJSON(value?: QuoteWorkRate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'unit': QuoteWorkUnitToJSON(value['unit']),
        'value': value['value'],
    };
}

